import { render, staticRenderFns } from "./AnchorageDockEdit.vue?vue&type=template&id=1f52bad3&scoped=true"
import script from "./AnchorageDockEdit.vue?vue&type=script&lang=js"
export * from "./AnchorageDockEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f52bad3",
  null
  
)

export default component.exports